













































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { FindMarcaUseCase, SaveMarcaUseCase } from '../../usecases'
import { Page, Marca } from '@/models'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { DataOptions } from 'vuetify'
import { Pageable } from '@/models/Pageable'
import axios, { CancelTokenSource } from 'axios'
import { ObserveVisibility } from 'vue-observe-visibility'

@Component({
	model: {
		prop: 'marca',
	},
	directives: {
		ObserveVisibility,
	},
})
export default class SeletorDeMarca extends Vue {
	@Prop({ type: [Object, Array], default: null }) marca!: (string | Marca) | (string | Marca)[] | null
	@Prop({ type: Boolean }) podeCriar!: boolean
	@Prop({ type: Boolean }) podeEditar!: boolean
	@Prop({ type: Boolean }) returnObject!: boolean
	@Prop({ type: Boolean }) multiple!: boolean
	busca: string | null = null
	itemEditando: null | ItemSelecao = null
	itensSelecao: ItemSelecao[] = []
	findMarcaUseCase = new FindMarcaUseCase()
	saveMarcaUseCase = new SaveMarcaUseCase()

	paginacao: DataOptions = {
		page: 0,
		itemsPerPage: 10,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

	pagina: Page<Marca> | null = null
	cancelToken: CancelTokenSource | null = null

	buscandoMaisItens = false
	buscandoNovosItens = true

	created() {
		this.buscarNovosItens()
	}

	marcaEmItemAutocompletar(marca: Marca | string): ItemSelecao {
		return typeof marca === 'string'
			? {
				id: '',
				nome: marca,
				lojas: [],
				tipo: 'selecao',
			}
			: {
				...marca,
				tipo: 'selecao',
			}
	}

	get itens() {
		let itens: ItemAutocompletar[] = this.marca === null
			? []
			: (Array.isArray(this.marca)
				? this.marca.map(this.marcaEmItemAutocompletar)
				: [this.marcaEmItemAutocompletar(this.marca)])

		itens = [
			...itens,
			...this.podeCriar
				? [{
					tipo: 'header',
					header: 'Selecione uma opção ou crie uma',
				} as ItemHeader]
				: [],
			...this.itensSelecao,
		]
		if (this.pagina && !this.pagina.last && !this.buscandoNovosItens)
			itens.push({ tipo: 'buscar-mais' })

		return itens
	}

	obterNomeMarca(marca: Marca | string) {
		return typeof marca === 'string'
			? marca
			: marca.nome
	}

	async selecionaItem(item: ItemSelecao) {
		if (!item) {
			this.$emit('input', null)
			return
		}
		this.$emit('input', item)
	}

	async criarMarca() {
		const nome = (this.busca ?? '').trim()
		this.busca = null
		try {
			if (!nome) return AlertModule.setError("Não pode ser vazio")
			const marcaNova: Marca = { id: '', nome, lojas: [] }

			const marcaCriada = await this.saveMarcaUseCase.create(marcaNova)

			const item: ItemSelecao = { ...marcaCriada, tipo: 'selecao' }
			this.itensSelecao.push(item)
			this.emitirInput(item)

			return marcaCriada
		} catch (e) {
			AlertModule.setError(e)
		}
	}

	emitirInput(item: ItemSelecao) {
		if (!Array.isArray(this.marca)) {
			this.$emit('input', this.returnObject
				? item
				: item.id,
			)
		} else {
			const marcas = this.marca || []
			this.$emit('input', [
				...marcas,
				item,
			])
		}
	}

	editar(item) {
		this.itemEditando = { ...item }
	}

	async confirmarEdicao() {
		if (!this.itemEditando) {
			return
		}
		if (!this.itemEditando.nome) {
			this.itemEditando = null
			return
		}
		const indice = this.itensSelecao.findIndex(
			item => item.id === this.itemEditando?.id,
		)
		if (indice === -1) return

		this.itensSelecao.splice(indice, 1, this.itemEditando)
		const marcaEditada = {
			id: this.itemEditando.id,
			nome: this.itemEditando.nome,
			lojas: [],
		}
		await this.saveMarcaUseCase.update(marcaEditada)
		this.itemEditando = null
	}

	async buscar(paginavel: Pageable = {}): Promise<Marca[]> {
		try {
			if (this.cancelToken) this.cancelToken.cancel()
			this.cancelToken = axios.CancelToken.source()

			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}

			this.pagina = await this.findMarcaUseCase.findMarcaPorUsuario({
				busca: this.busca || undefined,
				page: paginavel.page || 0,
				size: paginavel.size || 10,
				sort: 'nome',
			}, axiosConfig);
			this.paginacao.page = this.pagina.number
			return this.pagina.content
		} catch (e) {
			if (axios.isCancel(e)) throw e
			AlertModule.setError(e)
			throw e
		}
	}

	async buscarNovosItens() {
		this.buscandoNovosItens = true
		const marcas = await this.buscar({
			...this.paginacao,
			page: 0,
		})
		this.itensSelecao = []
		this.inserirMarcas(marcas)
		this.buscandoNovosItens = false
	}

	async buscarMaisItens() {
		this.buscandoMaisItens = true
		const marcas = await this.buscar({
			...this.paginacao,
			page: this.paginacao.page + 1,
		})
		this.inserirMarcas(marcas)
		this.buscandoMaisItens = false
	}

	inserirMarcas(marcas: Marca[]) {
		this.itensSelecao = [
			...this.itensSelecao,
			...marcas.map<ItemSelecao>(item => ({
				...item,
				tipo: 'selecao',
			})),
		]
	}

	@Watch('busca')
	onChangeBusca = this.buscarNovosItens

	mudouVisibilidade(visivel) {
		if (visivel && !this.buscandoMaisItens) this.buscarMaisItens()
	}
}

export type ItemHeader = {
	tipo: 'header'
	header: string
}

export type ItemSelecao = Marca & {
	tipo: 'selecao'
}

export type ItemBuscarMais = {
	tipo: 'buscar-mais'
}

export type ItemAutocompletar = ItemHeader | ItemSelecao | ItemBuscarMais
